<script lang="ts" setup>
import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'vue'

const props = withDefaults(
    defineProps<{
        title: string
        value: string | number
        class?: HTMLAttributes['class']
    }>(),
    {},
)
</script>

<template>
    <div :class="cn('rounded-lg bg-gray-50 p-4 lg:basis-1/3 lg:p-6', props.class)">
        <p class="text-sm lg:text-base">{{ props.title }}</p>
        <h3 class="mt-1 text-base font-semibold lg:mt-2 lg:text-xl">{{ props.value }}</h3>
    </div>
</template>
